import useDeviceSize from "./useDeviceSize";

export default useDeviceSize;
